import { showApiErrorToast } from './showApiErrorToast';

/**
 * Wraps a direct API call with automatic error toasting.
 *
 * Use in action classes (plain TypeScript, no React hooks) to eliminate
 * bare try/catch blocks. On error, `showApiErrorToast` is called and
 * `undefined` is returned — the error is never re-thrown.
 *
 * @example
 *   const data = await safeApiCall(() => ParticipantService.getById(id));
 *   if (data == null) return; // error already toasted
 *
 *   // With cleanup callback (e.g., dismiss a pending toast)
 *   const data = await safeApiCall(
 *     () => ax.request({ url, method: 'post', data: payload }),
 *     () => notify.dismiss(toastId),
 *   );
 */
export async function safeApiCall<T>(
  fn: () => Promise<T>,
  onError?: () => void,
): Promise<T | undefined> {
  try {
    return await fn();
  } catch (error) {
    onError?.();
    showApiErrorToast(error);
    return undefined;
  }
}
